module.exports = __webpack_public_path__ + "static/img/fr04.de98cd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fr04.png
// module id = yGR0
// module chunks = 18